import { slick, unslick } from "../template-parts/slider";

class NuSlickSlider extends HTMLElement {
    static observedAttributes = ["size", "options"];

    constructor() {
        super();

        this.rendered = false;
        this.slider = /** @type {HTMLElement} */ (
            this.querySelector(":scope .nu-slider")
        );

        if (!this.slider)
            throw new Error(
                "NuSlider requires a .nu-slider element as a direct child.",
            );
    }

    get size() {
        return this.getAttribute("size") || "medium";
    }

    get options() {
        return this.getAttribute("options") || "";
    }

    connectedCallback() {
        this.rendered = true;
        slick(this.slider, this.size, this.options);
    }

    disconnectedCallback() {
        this.rendered = false;
        unslick(this.slider);
    }

    /**
     * @param {string} old
     * @param {string} current
     */
    optionsChanged(old, current) {
        if (old === current || this.rendered === false) return;
        unslick(this.slider);
        slick(this.slider, this.size, current);
    }

    /**
     * @param {string} old
     * @param {string} current
     * */
    sizeChanged(old, current) {
        if (old === current || this.rendered === false) return;
        unslick(this.slider);
        slick(this.slider, current, this.options);
    }

    /**
     * @param {string} name
     * @param {string} oldVal
     * @param {string} newVal
     */
    attributeChangedCallback(name, oldVal, newVal) {
        // @ts-ignore Yes I know.
        if (this?.[`${name}Changed`]) {
            // @ts-ignore Yes I know. Up to implementer to make sure that a method exists for every observedAttributes.
            this[`${name}Changed`](oldVal, newVal);
        }
    }
}

customElements.define("nu-slick-slider", NuSlickSlider);
